// Whole minor units (pence, cents) for ad pixels that reject decimals: OpenAI's
// drops any event whose amount isn't an integer. Undefined when the amount isn't
// a number, so the key is left out rather than sent as 0. No imports, so any
// bundle can use it without pulling anything else in.
export default function toMinorUnits(value) {
    const amount = Number(value)
    if (value === null || value === undefined || value === '' || !Number.isFinite(amount)) {
        return undefined
    }

    const currency = (window.Alpine && window.Alpine.store('currency')) || (window.accuvars && window.accuvars.currency) || {}
    const factor = Number(currency.decimals) === 0 ? 1 : 100

    return Math.round((amount + Number.EPSILON) * factor)
}
